import { render, staticRenderFns } from "./ModalShare.vue?vue&type=template&id=1a95f2b0&"
import script from "./ModalShare.vue?vue&type=script&lang=js&"
export * from "./ModalShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports